import { Form } from 'react-bootstrap';
import 'styles/global.css';

/**
 * The standard Fusion drop down input field.
 * @param {{style: Object, options: string[], value: number, onChange: (value: number), disableSelect: boolean, disabled?: boolean}}
 * @returns A react component
 */
export default function FusionDropDownInput({
  options,
  value,
  onChange,
  disableSelect,
  label = '',
  disabled = false,
}) {
  return (
    <Form.Group className="d-flex flex-column w-100" disabled={disabled}>
      {label && (
        <Form.Label className="fs-6" htmlFor={label}>
          {label}
        </Form.Label>
      )}
      <Form.Select
        id={label}
        disabled={disabled}
        className="bg-primary rounded border border-1 border-secondary"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {!disableSelect && <option value={-1}>Select</option>}
        {options?.map((option, index) => (
          <option key={index} value={index} className="fs-6">
            {option}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
